var View = require('views/base/view');

var CompatibilityView = View.extend({
  autoRender: true,
  className: 'compatibility',
  autoAttach: true,
  template: require('./templates/compatibility'),
  initialize: function(options) {
    View.prototype.initialize.apply(this, arguments);
  }
});

module.exports = CompatibilityView;